
import { Component, Vue } from "vue-property-decorator";
import config from "@/config";

@Component
export default class EPDCertificate extends Vue {
  get url(): string {
    if (config.epdCertified == false) return "#";

    switch (this.$i18n.locale) {
      case "it-ch":
        return "https://www.cartellapaziente.ch/abilis";
      case "fr-ch":
        return "https://www.dossierpatient.ch/abilis";
      default:
        return "https://www.patientendossier.ch/abilis";
    }
  }

  get name(): string {
    return config.epdCertified ? (this.$t("global.epdBadgeAltTag") as string) : "Test Certificate";
  }

  get imagePath(): string {
    if (config.epdCertified == false) return "/images/epd-certificate-test.png";

    switch (this.$i18n.locale) {
      case "it-ch":
        return "/images/epd-certificate-it.svg";
      case "fr-ch":
        return "/images/epd-certificate-fr.svg";
      default:
        return "/images/epd-certificate-de.svg";
    }
  }
}
